import { render, staticRenderFns } from "./showPrice.vue?vue&type=template&id=840923d4&scoped=true"
import script from "./showPrice.vue?vue&type=script&lang=js"
export * from "./showPrice.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./showPrice.vue?vue&type=style&index=0&id=840923d4&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "840923d4",
  "21706d5c"
  
)

export default component.exports